import type { NavigationItemBase, URLGenerationStrategy } from "@/domains/navigation/navigation-item"

export class StaticURLStrategy implements URLGenerationStrategy {
  generateHref(item: NavigationItemBase): string {
    return item.href
  }
}
